import React, { FormEvent, useState } from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import figmaFSM from "figma-fsm";
import { FiniteStateMachineObject } from "figma-fsm/lib/transformations/transformCanvasToFiniteStateMachine";
import { Theme } from "@material-ui/core";

export interface FormStyleProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    form: {
      display: "flex",
      flexDirection: "column",
      marginTop: "48px",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row"
      }
    },
    input: {
      margin: "12px 0",
      minWidth: "250px",
      [theme.breakpoints.up("md")]: {
        margin: "0 12px"
      }
    },
    errorMessage: {
      marginTop: "24px"
    }
  });

interface FormProps {
  setFigmaFsmResult: React.Dispatch<React.SetStateAction<ReadonlyArray<FiniteStateMachineObject>>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const Form = ({ classes, setFigmaFsmResult, setIsLoading }: FormStyleProps & FormProps) => {
  const [accessToken, setAccessToken] = useState("");
  const [fileKey, setFileKey] = useState("");
  const [formError, setFormError] = useState("");

  const fetchFigmaFile = async (accessToken: string, fileKey: string) => {
    try {
      const result = (await figmaFSM(accessToken, fileKey)) as ReadonlyArray<
        FiniteStateMachineObject
      >;
      setFormError("");
      setFigmaFsmResult(result);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setFigmaFsmResult([]);
      setFormError("Oops, something went wrong. Check your api token and file key and try again.");
    }
  };

  const submitForm = (event: FormEvent) => {
    event.preventDefault();
    if (accessToken !== "" && fileKey !== "") {
      setIsLoading(true);
      fetchFigmaFile(accessToken, fileKey);
    } else {
      setFormError("Both the api token and the filekey are required fields.");
    }
  };

  const handleInputChange = (setFunction: React.Dispatch<React.SetStateAction<string>>) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFunction(event.target.value);
  };

  return (
    <>
      <form className={classes.form} noValidate autoComplete="off" onSubmit={submitForm}>
        <TextField
          id="figma-access-token"
          label="Figma Access Token"
          placeholder="Your Access Token here"
          margin="normal"
          variant="outlined"
          className={classes.input}
          onChange={handleInputChange(setAccessToken)}
        />
        <TextField
          id="figma-file-key"
          label="Figma File Key"
          placeholder="Your File Key here"
          margin="normal"
          variant="outlined"
          className={classes.input}
          onChange={handleInputChange(setFileKey)}
        />
        <Button type="submit" color="primary" variant="contained">
          Transform
        </Button>
      </form>
      {formError !== "" && (
        <Typography className={classes.errorMessage} color="secondary" variant="subtitle1">
          {formError}
        </Typography>
      )}
    </>
  );
};

export default withStyles(styles)(Form);
